import React from 'react';
import { View, TextInput } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import { FontAwesome } from '@expo/vector-icons';

export default function TextInputContainer({...props}){
  const iconSize = 24;
  const secure = ['password', 'newPassword'].includes(props.textContentType);
  const disabled = props.editable === undefined ? false : !props.editable;
  const disabledStyling = props.disabledStyling === undefined ? true : props.disabledStyling;
  // const textContentType = props.textContentType ?? 'none';

  return (
    <View style={[CS.textInputContainer, (props.isInvalid && CS.textInputContainerInvalid), (disabled && disabledStyling && CS.textInputContainerDisabled), props.inputContainerStyle]}>
      {/* <View style={CS.inputIconContainer}> */}
      {props.iconName &&
        <FontAwesome
          name={props.iconName}
          size={props.iconSize || iconSize}
          color={props.isInvalid ? Colors.invalid : (disabled && disabledStyling ? Colors.mediumGrey : Colors.lightGrey)}
          style={CS.inputIcon}
        />
      }
      {/* </View> */}
      <TextInput 
        style={[CS.textInput, (props.isInvalid && CS.textInputInvalid), (disabled && disabledStyling && CS.textInputDisabled), props.inputStyle]}
        placeholderTextColor={Colors.lightBlue} 
        selectionColor={Colors.yellow} 
        secureTextEntry={secure}
        ref={props.inputRef}
        underlineColorAndroid={'transparent'}
        // onChangeText={(text) => props.onChange(text)}
        // placeholder={props.placeholder} 
        {...props} // Inherit any props passed to it; e.g., placeholder, onChangeText
      />
    </View>
  )
}